import { Languages } from 'src/common/descriptions/types'
import { SessionData, SessionDataField } from './types'

export const getSessionData = (): SessionData => ({
    accessToken: localStorage.getItem(SessionDataField.ACCESS_TOKEN) || '',
    user: JSON.parse(localStorage.getItem(SessionDataField.USER) as string),
    language: localStorage.getItem(SessionDataField.SYS_LANG) as Languages || Languages.SPANISH_US,
})

export const storeSessionData = (sessionData: SessionData) => {
    if (sessionData.accessToken !== undefined) {
        localStorage.setItem(SessionDataField.ACCESS_TOKEN, sessionData.accessToken)
    }
    if (sessionData.user !== undefined) {
        localStorage.setItem(SessionDataField.USER, JSON.stringify(sessionData.user))
    }
    if (sessionData.language !== undefined) {
        localStorage.setItem(SessionDataField.SYS_LANG, sessionData.language)
    }
}

export const removeSessionData = (sessionDataField: SessionDataField) => {
}

export const clearSessionData = () => {
    const itemsToRemove: SessionDataField[] = [
        SessionDataField.ACCESS_TOKEN,
        SessionDataField.USER,
    ]

    itemsToRemove.map(item => localStorage.removeItem(item))
}